/**
 * Enum Definitions
 *
 * This module contains all enum definitions used across the scenarios simulator.
 * Centralizing enums follows DRY principle and makes them easy to maintain.
 */

import { z } from 'zod';

// ============================================
// SIMULATION ENUMS
// ============================================

export const SimulationStatusEnum = z.enum(
  [
    'SIMULATION_DRAFT',
    'SIMULATION_INITIALIZING',
    'PREPARING_PROJECTIONS_COMPONENTS',
    'RUNNING_SCENARIO_PROJECTIONS',
    'RUNNING_BENCHMARKING_CASES',
    'RUNNING_HIGHLIGHTS',
    'DRAFT_WITH_CALCULATIONS_COMPLETED',
    'SIMULATION_COMPLETED',
    'SIMULATION_FAILED',
    'SIMULATION_ABORTED',
    'OPTIMIZED_SIMULATION_INITIALIZING',
  ],
  {
    errorMap: () => ({ message: 'Campo é obrigatório' }),
  },
);

export const DocumentFormatEnum = z.enum(['PNG', 'PDF'], {
  errorMap: () => ({ message: 'Campo é obrigatório' }),
});

export const PresetTypeEnum = z.enum(['ACR', 'CLARKE_ACL', 'COMPETITOR_ACL', 'undefined'], {
  errorMap: () => ({ message: 'Campo é obrigatório' }),
});

export const DocTypeEnum = z.enum(['CPF', 'CNPJ'], {
  errorMap: () => ({ message: 'Campo é obrigatório' }),
});

export const EnergyTypeEnum = z.enum(['INCENTIVIZED_50', 'INCENTIVIZED_100', 'CONVENTIONAL'], {
  errorMap: () => ({ message: 'Campo é obrigatório' }),
});

export const LogKindEnum = z.enum(['DEBUG', 'INFO', 'WARNING', 'ERROR'], {
  errorMap: () => ({ message: 'Campo é obrigatório' }),
});

export const ErrorLocationEnum = z.enum(['UNIT_PROJECTIONS', 'SCENARIO_PROJECTIONS', 'BENCHMARKING'], {
  errorMap: () => ({ message: 'Campo é obrigatório' }),
});

export const TariffGroupEnum = z.enum(
  ['A4_GREEN', 'A4_BLUE', 'AS_BLUE', 'AS_GREEN', 'A3_BLUE', 'A2_BLUE', 'B3_STANDARD', 'B3_OPTING'],
  {
    errorMap: () => ({ message: 'Campo é obrigatório' }),
  },
);

// Re-export RiskTypeEnum from its original location
export { RiskTypeEnum } from './enums';
